import { queryKeys } from '@/lib/api/query-keys';

/** Query-key factory for the Reports feature. Only the three dropdown sources need keys today —
 *  the four grids are keyed by `<DataTable>`'s own `tableId`. Each meta key varies by `search`
 *  because `useCursorSelect` resets its cursor when the key changes, and a cursor is only valid for
 *  the term it was issued under. All three tabs that use the Customers dropdown share one key, so
 *  the option list is fetched once. */
export const reportKeys = {
  all: ['reports'] as const,
  /** Each option list sits under the entity it lists, so that entity's writes invalidate it. */
  metaCustomers: (search: string) => queryKeys.customers.meta('reports', { search }),
  metaDevices: (search: string) => queryKeys.devices.meta('reports', { search }),
  /** Under the Category root so a Category write invalidates the filter's options. */
  metaCategories: (search: string) =>
    queryKeys.categories.meta('reports', { isOwned: true, search }),
};
